/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
//
import { LogLevel } from "@azure/msal-browser";



/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfigOneDrive = {

    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID_ONEDRIVE}`,
        // authority: 'https://login.microsoftonline.com/619e851e-8e70-43fc-a9a4-d609af5db018',
        // authority: 'https://login.microsoftonline.com/common',
        // authority: "Enter_the_Cloud_Instance_Id_HereEnter_the_Tenant_Info_Here",
        redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
        // redirectUri: `http://localhost:3001/auth/redirect`,
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: [`${process.env.REACT_APP_CLIENT_ID_ONEDRIVE}/.default`],
    // scopes: [`https://graph.microsoft.com/.default`],
    extraScopesToConsent: ['api://6de808b1-50d2-4ccb-b94f-b8024fecd432/onedrive-integrations-app-service'],
    scopes: ['offline_access', 'User.Read', 'Files.ReadWrite.All'],
    prompt: "select_account"
    // scopes: ['api://6de808b1-50d2-4ccb-b94f-b8024fecd432/onedrive-integrations-app-service']
};

export const loginRequestJWT = {
    scopes: ['api://6de808b1-50d2-4ccb-b94f-b8024fecd432/onedrive-integrations-app-service'],
    prompt: "select_account"
};

export const apiRequest = {
    url: 'https://pbi-prototype.azurewebsites.net/api/getEmbedToken',
    scopes: [`api://6de808b1-50d2-4ccb-b94f-b8024fecd432/onedrive-integrations-app-service`],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
